<template>
    <div class="res-section">
      <div class="res-content">
        <h2 class="mistica-style-h3">¿Qué recibirás (según perfil)?</h2>
        <div class="row spacing-make">
          <div class="col-md-6 spacing-col">
            <img src="../../../src/assets/img/Group 68.png" alt="porcentaje 1" class="icon-diagnosis" />
            <p class="description-make text-center">
              <b style="color: #C58911;">Reportan más conexión emocional con su hijo.</b>
              <br>
              Después del diagnóstico y la retroalimentación, las conversaciones familiares cambian. Hay más apertura, más empatía y menos tensión.
            </p>
          </div>
          <div class="col-md-6 spacing-col">
            <img src="../../../src/assets/img/Group 69.png" alt="porcentaje 2" class="icon-diagnosis" />
            <p class="description-make text-center">
              <b style="color: #C58911;">Dicen entender mejor su motivación.</b>
              <br>
              Descubrir las verdaderas fuentes de interés y frustración permite acompañar con inteligencia emocional, no desde la intuición ni desde el miedo.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="description-our-make">
              Porque entender a tu hijo con claridad es el primer paso para acompañarlo con confianza hacia un futuro que realmente tenga sentido para él.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <img src="../../../src/assets/img/Group 67.png" alt="users" class="icon-users" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="description-our-make">
              <b style="color: #C58911;">9 de cada 10 padres</b> afirman que ahora saben cómo ayudar sin imponer. Y eso, en el momento que viven sus hijos, marca toda la diferencia.
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResultsSection'
  }
  </script>

<style>
    .res-section {
        width: 100%;
        height: 1400px;
        background-color: #000 !important; /* Fondo negro forzado */
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        box-sizing: border-box;
    }
    
    .res-content {
        display: flex;
        max-height: 1440px;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        text-align: center;
    }

    .mistica-style-h3 {
        font-family: 'Open Sans', sans-serif;
        font-weight: 600;
        font-size: 64px;
        align-items: center;
        color: #C58911;
        padding-bottom: 5%;
        padding: 50px 80px;
        transform: scaleY(1.2);
    }

    @media (max-width: 768px) {
      .mistica-style-h3 {
        font-size: 2rem !important;
        padding: 12px 4vw 8px 4vw;
        padding-bottom: 10px;
        line-height: 1.2;
        word-break: break-word;
        margin: 0;
      }
    }
</style>